export default class Color {
    static diverse() {
        return [];
    }
}
